import { render, staticRenderFns } from "./MapPelaksanaan.vue?vue&type=template&id=2ca07b1a&scoped=true&"
import script from "./MapPelaksanaan.vue?vue&type=script&lang=js&"
export * from "./MapPelaksanaan.vue?vue&type=script&lang=js&"
import style0 from "./MapPelaksanaan.vue?vue&type=style&index=0&id=2ca07b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca07b1a",
  null
  
)

export default component.exports